// src/components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTopOnRouteChange = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the pathname changes
    }, [pathname]);

    return null; // This component doesn't render anything
};

export default ScrollToTopOnRouteChange;
